// Actions
import AppActions from 'app/shared/flux/actions/AppActions';
import ErrorActions from 'app/shared/flux/actions/ErrorActions';

// Types
import type { ThunkDispatch } from 'redux-thunk';
import type { AnyAction } from 'redux';
import type { RootReduxState } from 'app/shared/flux/reducers/index';

// Define interfaces for better type safety
interface Trace {
  finishAsyncSpan: (params: { marker: string }) => void;
}

interface ReduxStore {
  getState: () => RootReduxState;
  dispatch: ThunkDispatch<RootReduxState, undefined, AnyAction>;
}

interface ReactContext {
  ip: string;
  store: ReduxStore;
  trace: Trace | null | undefined;
}

const loadGeolocation = (reactContext: ReactContext): Promise<unknown> => {
  const { ip, store, trace } = reactContext;

  return store
    .dispatch(AppActions.getGeoIp({ ip, trace: null }))
    .then((response: unknown) => {
      if (trace) {
        trace.finishAsyncSpan({
          marker: 'FetchAreaWrapper#loadGeolocationData',
        });
      }
      return response;
    })
    .catch((error: Error) => {
      store.dispatch(
        ErrorActions.errorHandler({
          error,
          errorClass: error.constructor.name,
          errorLocation: 'AppTemplate#serverRouteWillMount',
          req: {},
          criticalType: null,
        }),
      );
    });
};

export default loadGeolocation;
